import { ROUTE_PERMISSIONS } from '@shared/permissions';
import { lazyWithReload } from '@shared/react/lazyWithReload';
import { PermissionGuard, ValidUuidGuard } from '@shared/router';
import { Route } from 'react-router';

import { refundDeclineRoute, refundDetailRoute, refundsPath } from './urls';

const RefundListView = lazyWithReload(() =>
  import('./pages/RefundList').then((m) => ({ default: m.Container }))
);
const RefundDetailView = lazyWithReload(() =>
  import('./pages/RefundDetail').then((m) => ({ default: m.Container }))
);
const RefundDeclineView = lazyWithReload(() =>
  import('./pages/RefundDecline').then((m) => ({ default: m.RefundDecline }))
);

export const RefundRoutes = (
  <>
    <Route
      path={refundsPath}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.refunds}>
          <RefundListView />
        </PermissionGuard>
      }
    />
    <Route
      path={refundDetailRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.refundsDetail}>
          <ValidUuidGuard paramName="id">
            <RefundDetailView />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
    <Route
      path={refundDeclineRoute}
      element={
        <PermissionGuard requiredPermissions={ROUTE_PERMISSIONS.refundsDecline}>
          <ValidUuidGuard paramName="id">
            <RefundDeclineView />
          </ValidUuidGuard>
        </PermissionGuard>
      }
    />
  </>
);
